import GlobalsearchView from '@/components/Globalsearch/GlobalsearchView.vue';
import { useKeyboardListener, useDialog } from '@/composeables';
import type { IDialogOpenedCallbackParams } from '@/composeables/dialog/IDialogOpenedCallbackParams';
import type { TypeAheadItem } from '@/objects/generated';
import { useEventStore } from '@/stores';
import { OpenContestantModal } from '@/utilities';

let searchDialog: IDialogOpenedCallbackParams<InstanceType<typeof GlobalsearchView>, boolean> | null = null;

export const initGlobalSearch = () => {
    const { addKeyboardShortcut } = useKeyboardListener();

    // Register the global keyboard shortcut to open the global search
    addKeyboardShortcut({
        alias: 'Global',
        on: 'CTRL+SHIFT+SPACE',
        action: async () => {
            // No global search if we are not in an event, since the only thing we can search for so far is contestants
            if (useEventStore().eventID === 0) {
                return;
            }

            // Create a function for routing the response

            // Open a dialog to search for a bib number and then navigate to the contestant
            searchDialog = await useDialog().Ok({
                title: 'globalsearch.title',
                body: GlobalsearchView,
                componentProps: {
                    onItemSelected: handleSelectedSearchItem,
                },
                okCallback: () => true,
                userClosedAction: async () => false,
                options: {
                    Size: 'md',
                    DisableAnimation: true,
                },
            });
        },
    });
};

const handleSelectedSearchItem = async (item: TypeAheadItem) => {
    // TODO: We need some kind of type to know what type of item it is
    // For now we just assume it is a contestant

    await searchDialog?.closeDialog();

    OpenContestantModal({ raceContestantId: item.ID });
};
